import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { logger } from 'redux-logger';
import rootReducer from './reducers';

import { rootSaga } from 'sagas/index';

// Initialize state
const initialState = {};

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-saga actions that may carry FormData or other non-serializables
        ignoredActions: [
          'SG_ADD_PUBLIC_UPLOAD',
          'SG_EDIT_PUBLIC_UPLOAD',
        ],
        // Ignore state paths if any saga store temp objects (none currently)
        ignoredPaths: [],
      },
    }).concat(sagaMiddleware, logger),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
});

sagaMiddleware.run(rootSaga);

export default store;
